/* GlobifySIM – sales elements
 *
 * Popup mit dem Rabattcode, echter Countdown auf ein hinterlegtes Enddatum,
 * klebrige Leiste am unteren Rand. Alles ohne erfundene Knappheit: der
 * Countdown läuft nur, wenn ein Enddatum gepflegt ist, und blendet sich
 * danach aus, statt neu zu starten.
 */
(function () {
  "use strict";

  var SPEICHER = "gs_popup_gesehen";

  function gesehen(tage) {
    try {
      var wert = window.localStorage.getItem(SPEICHER);
      if (!wert) return false;
      return (Date.now() - parseInt(wert, 10)) < tage * 86400000;
    } catch (e) { return false; }
  }

  function merken() {
    try { window.localStorage.setItem(SPEICHER, String(Date.now())); } catch (e) {}
  }

  /* -------------------------------------------------------- Countdown */

  function countdown(el) {
    var ende = new Date(el.getAttribute("data-gs-countdown"));
    if (isNaN(ende.getTime())) { el.style.display = "none"; return; }

    var felder = {
      tage: el.querySelector("[data-gs-cd-tage]"),
      std: el.querySelector("[data-gs-cd-std]"),
      min: el.querySelector("[data-gs-cd-min]"),
      sek: el.querySelector("[data-gs-cd-sek]")
    };

    function tick() {
      var rest = ende.getTime() - Date.now();
      if (rest <= 0) {
        /* Angebot vorbei: ausblenden statt neu starten */
        el.style.display = "none";
        var eltern = el.closest("[data-gs-angebot-block]");
        if (eltern) eltern.style.display = "none";
        window.clearInterval(uhr);
        return;
      }
      var s = Math.floor(rest / 1000);
      var t = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sek = s % 60;
      if (felder.tage) felder.tage.textContent = t;
      if (felder.std) felder.std.textContent = ("0" + h).slice(-2);
      if (felder.min) felder.min.textContent = ("0" + m).slice(-2);
      if (felder.sek) felder.sek.textContent = ("0" + sek).slice(-2);
    }

    tick();
    var uhr = window.setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------ Popup */

  function popup(wurzel) {
    var kasten = wurzel.querySelector("[data-gs-popup-kasten]");
    var zu = wurzel.querySelectorAll("[data-gs-popup-zu]");
    var tage = parseInt(wurzel.getAttribute("data-gs-tage") || "7", 10);
    var verzoegerung = parseInt(wurzel.getAttribute("data-gs-verzoegerung") || "18", 10) * 1000;
    var anteil = parseInt(wurzel.getAttribute("data-gs-scroll") || "45", 10);
    if (!kasten || gesehen(tage)) return;

    var offen = false;

    function zeigen() {
      if (offen) return;
      offen = true;
      wurzel.classList.add("ist-offen");
      merken();
      document.removeEventListener("mouseout", beiAustritt);
      window.removeEventListener("scroll", beiScroll);
    }

    function schliessen() {
      wurzel.classList.remove("ist-offen");
    }

    function beiAustritt(e) {
      if (!e.relatedTarget && e.clientY <= 4) zeigen();
    }

    function beiScroll() {
      var hoehe = document.body.scrollHeight - window.innerHeight;
      if (hoehe <= 0) return;
      if ((window.pageYOffset / hoehe) * 100 >= anteil) zeigen();
    }

    /* Am Rechner beim Verlassen, auf dem Handy nach Scrolltiefe, sonst nach Zeit */
    document.addEventListener("mouseout", beiAustritt);
    window.addEventListener("scroll", beiScroll, { passive: true });
    window.setTimeout(zeigen, verzoegerung);

    for (var i = 0; i < zu.length; i++) zu[i].addEventListener("click", schliessen);
    wurzel.addEventListener("click", function (e) { if (e.target === wurzel) schliessen(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") schliessen(); });
  }

  /* ---------------------------------------------------- Klebrige Leiste */

  function leiste(el) {
    var schwelle = parseInt(el.getAttribute("data-gs-ab") || "600", 10);

    /* Die tatsächliche Höhe an das Stylesheet melden, damit sich die
       schwebenden Knöpfe darüber staffeln statt sich zu überlagern. */
    function hoeheMelden(sichtbar) {
      var h = sichtbar ? el.offsetHeight : 0;
      document.documentElement.style.setProperty("--gs-leiste-hoehe", h + "px");
    }

    function pruefen() {
      var sichtbar = window.pageYOffset > schwelle;
      var vorher = el.classList.contains("ist-sichtbar");
      el.classList.toggle("ist-sichtbar", sichtbar);
      if (sichtbar !== vorher) hoeheMelden(sichtbar);
    }

    window.addEventListener("scroll", pruefen, { passive: true });
    pruefen();

    window.addEventListener("resize", function () {
      hoeheMelden(el.classList.contains("ist-sichtbar"));
    });

    var zu = el.querySelector("[data-gs-leiste-zu]");
    if (zu) zu.addEventListener("click", function () {
      el.remove();
      document.documentElement.style.setProperty("--gs-leiste-hoehe", "0px");
    });
  }

  /* ------------------------------------------------------------ Start */

  document.addEventListener("DOMContentLoaded", function () {
    var uhren = document.querySelectorAll("[data-gs-countdown]");
    for (var i = 0; i < uhren.length; i++) countdown(uhren[i]);

    var p = document.querySelector("[data-gs-popup]");
    if (p) popup(p);

    var l = document.querySelectorAll("[data-gs-leiste]");
    for (var j = 0; j < l.length; j++) leiste(l[j]);
  });
})();
